import { debounce } from 'lodash';

const DATATABLE_PREFIX = 'wastedesk-table-';

/**
 * Drop the DataTables global search from a saved table state.
 *
 * Tables are filtered through their column headers only, so the global search
 * must not be stored or restored at all - not in localStorage, not in the user
 * preferences. Per-column terms (`columns[i].search`) are kept untouched.
 */
export function stripGlobalSearch(state) {
    if (!state || typeof state !== 'object' || !('search' in state)) {
        return state;
    }
    const { search, ...rest } = state;
    return rest;
}

export function syncDbToLocalStorage(user) {
    if (user && user.preferences && user.preferences.datatables_settings) {
        const dbSettings = user.preferences.datatables_settings;
        for (const key in dbSettings) {
            if (Object.hasOwnProperty.call(dbSettings, key) && key.startsWith(DATATABLE_PREFIX)) {
                try {
                    localStorage.setItem(key, JSON.stringify(stripGlobalSearch(dbSettings[key])));
                } catch (e) {
                    console.error(`Failed to write datatable setting to localStorage for key: ${key}`, e);
                }
            }
        }
    }
}

const syncLocalStorageToDb = store => {
    const user = store.getters['auth/user'];
    const loggedIn = store.state.auth.status.loggedIn;
    const firstSyncDone = store.state.auth.datatablesFirstSyncDone;

    if (!user || !user.id || !loggedIn || !firstSyncDone) return;

    const dtSettings = {};
    let foundSettings = false;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(DATATABLE_PREFIX)) {
            try {
                const item = JSON.parse(localStorage.getItem(key));
                if (item && item.order) {
                    dtSettings[key] = stripGlobalSearch(item);
                    foundSettings = true;
                }
            } catch (e) {
                console.error(`Failed to parse datatable setting from localStorage for key: ${key}`, e);
            }
        }
    }

    if (!foundSettings) return;

    const newPreferences = {
        ...user.preferences,
        datatables_settings: {
            ...(user.preferences.datatables_settings || {}),
            ...dtSettings,
        },
    };

    const payload = {
        id: user.id,
        updType: 'partial',
        preferences: newPreferences,
    };

    store.dispatch('auth/updateUser', payload).catch(err => {
        console.error('Failed to sync datatable settings to DB:', err);
    });
};

export const debouncedSyncLocalStorageToDb = debounce(syncLocalStorageToDb, 2500);
